import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Panel
} from 'react-bootstrap';
import { SwitchButton } from 'components/switch-button';
import {AssigneeNotice} from './assignee-notice';

class SettingProjectEmail extends Component {
  static propTypes = {
    projectOperation: PropTypes.object,
    onSaveProjectOperation: PropTypes.func,
    assigneeNotice: PropTypes.any,
    isDisabledSwitchButton: PropTypes.bool,
    isNotAllowedEdit: PropTypes.bool,
    onSaveAssigneeNotice: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      switch: false,
      expandSetting: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.projectOperation) {
      this.setState({
        switch: nextProps.projectOperation.sendProjectNotification
      });
    }

    if (nextProps.isNotAllowedEdit) {
      this.setState({expandSetting: false});
    }
  }

  onSaveProjectOperation = () => {
    this.props.onSaveProjectOperation(this.state.switch);
  }

  onChangeSwitch = () => {
    this.setState({
      switch: !this.state.switch
    }, () => {
      this.setState({ expandSetting: this.state.switch });
      this.onSaveProjectOperation();
    });
  }

  handleTitleClick = () => {
    if (this.state.switch && !this.props.isNotAllowedEdit) {
      this.setState({
        expandSetting: !this.state.expandSetting
      });
    }
  }

  renderCaretIcon = () => {
    if (!this.props.isNotAllowedEdit) {
      if (this.state.expandSetting) {
        return <span><i className='pe-7s-angle-down expand-ic' /></span>;
      } else {
        return <span><i className='pe-7s-angle-right expand-ic' /></span>;
      }
    } else {
      return null;
    }
  }

  render() {
    return (
      <Panel expanded={this.state.expandSetting} onToggle={() => {}}>
        <Panel.Heading className={this.props.isNotAllowedEdit ? 'panel-disabled' : ''}>
          <Panel.Title
            onClick={this.handleTitleClick}
            style={this.state.switch ? {cursor: 'pointer'} : {}}>
              Auto-send follow up emails to work order assignees
            {this.renderCaretIcon()}
          </Panel.Title>
          <SwitchButton
            className='pull-right'
            ref={c => { this.switch = c; }}
            name='switch1'
            style={this.props.isDisabledSwitchButton ? {display: 'inline-block', opacity: .5} : {display: 'inline-block'}}
            checked={this.state.switch}
            disabled={this.props.isDisabledSwitchButton || this.props.isNotAllowedEdit}
            onCheck={this.onChangeSwitch} />
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <AssigneeNotice
              assigneeNotice={this.props.assigneeNotice}
              onSaveAssigneeNotice={(data) => this.props.onSaveAssigneeNotice(data)} />
            <div className={this.props.isNotAllowedEdit ? 'faded-layer' : null} />
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default SettingProjectEmail;




// WEBPACK FOOTER //
// ./src/Setting/Components/setting-project-email.js